import React from "react";

import { faSync } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import { EnvdDocumentAction } from "actions/envd";

import AgGridTable from "components/AgGrid/AgGridContainer";
import { EnvdDocumentColumns } from "components/Importer/columnDefinitions";
import { Column } from "components/Layout";

import { AgGridTables } from "constants/aggrid";

import {
  getSales,
  selectDeploymentOptions,
  selectSaleOptionsV2,
} from "selectors";

import { selectEnvdDocumentsAggridData } from "selectors/aggrid/envd";

import { useDebounceSelector } from "hooks";

const getRowId = params => params.data.envdDocument.id;

export function EnvdDocuments() {
  const sales = useSelector(getSales);
  const livestockSaleOptions = useSelector(selectSaleOptionsV2);
  const deploymentOptions = useSelector(selectDeploymentOptions);

  const rowData = useDebounceSelector(selectEnvdDocumentsAggridData);

  const dispatch = useDispatch();

  const updateEnvdDocument = data => {
    const patch = {
      id: data.envdDocument.id,
      livestockSaleId: data.livestockSaleId,
      deploymentId: data.deploymentId,
      excludedFromLivestockSaleIds:
        data.envdDocument.excludedFromLivestockSaleIds.filter(
          // When explicitly mapping to a sale, make sure it's no longer excluded
          id => data.livestockSaleId === null || id !== data.livestockSaleId,
        ),
    };
    dispatch(EnvdDocumentAction.update(patch));
  };

  const context = {
    deploymentOptions,
    sales,
    saleOptions: livestockSaleOptions,
    update: updateEnvdDocument,
  };

  const additionalActions = [
    {
      title: "Refresh",
      icon: faSync,
      onClick: () => dispatch(EnvdDocumentAction.refresh()),
      default: true,
      dataTour: "refreshEnvd",
    },
  ];

  return (
    <Column fullWidth>
      <AgGridTable
        additionalActions={additionalActions}
        columnDefs={EnvdDocumentColumns}
        context={context}
        rowData={rowData}
        tableName={AgGridTables.ENVD_MAPPING}
        getRowId={getRowId}
        singleClickEdit
        stopEditingWhenCellsLoseFocus
      />
    </Column>
  );
}
